import Hook from "../../utils/hook"

export const ProfilePageCollectionMap = Hook(`ProfilePageCollectionMap`, {
  refs: [`map`],
  values: { phxHideModal: String },

  mapRefMounted(mapRef) {
    mapRef.addReceiveHandler(this.mapReceive.bind(this))
  },

  mapReceive(message) {
    switch (message.method) {
      case `loaded`: {
        if (this.mapRef) this.mapRef.send(`setFullscreenIfIsMobile`, true)
        break
      }

      case `closeRequested`: {
        if (this.phxHideModalValue) this.js().exec(this.phxHideModalValue)
        break
      }
    }
  },
})
